<div class="container-fluid">
  <div class="col-md-12" *ngIf="isLoading">
    <app-busy [message]="message"></app-busy>
  </div>
  <!-- <div class="row">
    <div style="margin-top:10px; margin-bottom:-10px;">
      <h5><span style="padding-right:15px"></span> <i class="fa fa-cogs"></i><b> Manage {{this.lblHeading}}</b></h5>
    </div>
  </div> -->
  <div class="page_header flex_row" style="margin-top:20px!important; margin-bottom:10px!important">
    <h1 class="heading">Digital Routes</h1>
    <app-filter></app-filter>
  </div>
  <button id="btnSearch" style="width: 0px; display: none;" (click)="onSearch()" visibility="hidden">
  </button>
  <div class="row">
    <div class="col-md-12">
      <button title="Add new route" [routerLink]="['/route/management/add']" type="submit" id="btnSave"
      class="btn hd-btn" >Add new</button>
        <br/>
        <br/>
    </div>
  </div>
  <div class="table-responsive">
    <table cellspacing="0" class="table custom_table">
      <thead>
        <tr>
          <th class="th-sm" >
            Code
            <i style="vertical-align:middle;" class="fa fa-sort" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"
               (click)="utility.onSort(1)"></i>
          </th>
          <th class="th-sm">
            Route Name
            <i style="vertical-align:middle;" class="fa fa-sort" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagDN == 2),'fa-sort-desc sort-d': (utility.flags.flagDN == 3), 'fa-sort':(utility.flags.flagDN == 1) }"
               (click)="utility.onSort(2)"></i>
          </th>
          <th class="th-sm">
            Description
            <i style="vertical-align:middle;" class="fa fa-sort" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagDN == 2),'fa-sort-desc sort-d': (utility.flags.flagDN == 3), 'fa-sort':(utility.flags.flagDN == 1) }"
               (click)="utility.onSort(4)"></i>
          </th>
          <th class="th-sm">
            Permit Type
            <i style="vertical-align:middle;" class="fa fa-sort" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagDN == 2),'fa-sort-desc sort-d': (utility.flags.flagDN == 3), 'fa-sort':(utility.flags.flagDN == 1) }"
               (click)="utility.onSort(3)"></i>
          </th>
          <th class="th-sm">
            Route Type
            <i style="vertical-align:middle;" class="fa fa-sort" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagDN == 2),'fa-sort-desc sort-d': (utility.flags.flagDN == 3), 'fa-sort':(utility.flags.flagDN == 1) }"
               (click)="utility.onSort(6)"></i>
          </th>
          <!-- <th style="vertical-align:middle;" class="bfr-end-col">
            Active?
            <i style="vertical-align:middle;" class="fa fa-sort" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagAE == 2),'fa-sort-desc sort-d': (utility.flags.flagAE == 3), 'fa-sort':(utility.flags.flagAE == 1) }"
               (click)="utility.onSort(3)"></i>
          </th> -->
          <th style="vertical-align:middle;" class="bfr-end-col">
            Stops           
          </th>
          <th style="vertical-align:middle;" class="bfr-end-col">
            Est. Distance              
          </th>
          <th style="vertical-align:middle;" class="bfr-end-col">
            Est. Duration              
          </th>
          <!-- <th style="vertical-align:middle;" class="bfr-end-col">
            Sort Order
            <i style="vertical-align:middle;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagSO == 2),'fa-sort-desc sort-d': (utility.flags.flagSO == 3), 'fa-sort':(utility.flags.flagSO == 1) }"
               (click)="utility.onSort(5)"></i>
          </th>
          <th style="vertical-align:middle;" class="bfr-end-col">
            Group
            <i style="vertical-align:middle;" class="fa fa-sort" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagGC == 2),'fa-sort-desc sort-d': (utility.flags.flagGC == 3), 'fa-sort':(utility.flags.flagGC == 1) }"
               (click)="utility.onSort(4)"></i>
          </th>
          <th style="vertical-align:middle;" class="bfr-end-col">Display?</th> -->
          <th class="btn-show hgt-btn bfr-end-col text-center">
           Actions
          </th>
        </tr>
      </thead>
      <tr *ngFor="let cType of routes  | paginate: { itemsPerPage: showNum, currentPage: utility.page }">
        <td class="bfr-end-col">{{cType.code}}</td>
        <td class="bfr-end-col">{{cType.description}}</td>
        <td class="bfr-end-col">{{cType.route_summary}}</td>
        <td class="bfr-end-col">{{cType.freight_passenger_ind}}</td>
        <td class="bfr-end-col">{{cType.route_type_ind}}</td>
        <!-- <td class="bfr-end-col">{{cType.is_active}}</td> -->
        <td class="bfr-end-col">{{cType.num_border_crossings}}</td>
        <td class="bfr-end-col">{{cType.distance}} km</td>
        <td class="bfr-end-col">{{cType.duration}}</td>
        <!-- <td class="bfr-end-col">{{cType.sort_order}}</td>
        <td class="bfr-end-col">{{cType.group_code}}</td>
        <td class="bfr-end-col">{{utility.showDisplayIndicator(cType.display_ind)}}</td> -->
        <td class="btn-show bfr-end-col text-center">
          <a [routerLink]="['/route/management/edit',cType.id]"><img src="../../../assets/newimg/border-color-13@2x.png" title="Edit Route" style="cursor: pointer;width: 18px;"/></a>
          <img src="../../../../../assets/newimg/delete-30@2x.png" title="Delete Route" (click)="onConfirm(cType.id)" style="cursor: pointer; margin-left: 20px; width: 18px;"/>
          <!-- <a [routerLink]="['/route/management/edit',cType.id]"><span title="Edit Route" style="margin: 0%" class="btn btn-success btn-sm"><i class="fa fa-pencil fa-fw"></i></span></a> -->
          <!-- <span title="Delete Route" style="margin: 0%" class="btn btn-danger btn-sm" (click)="onConfirm(cType.id)"><i class="fa fa-trash-o fa-fw"></i></span> -->
        </td>
      </tr>
      
      <tfoot>
        <tr *ngIf="routes.length > 4" class="pagination_row">
          <td colspan="12" class="rm-brd">
            <div class="row">
              <div class="col-4">
                <div class="input-group mb-3 rm-brd" style="width:125px!important;height:30px!important;">
                  <div class="input-group-prepend">
                    <label class="input-group-text form-control-sm show-h" for="show-id">Show:</label>
                  </div>
                  <select class="form-control form-control-sm show-h" id="show-id" [(ngModel)]="showNum">
                    <option *ngFor="let key of utility.pageItems" [ngValue]="key">{{key}}</option>
                  </select>
                </div>
              </div>
              <div class="col-8 text-right">
                <pagination-controls (pageChange)="utility.page = $event"></pagination-controls>
              </div>
            </div>
          </td>

        </tr>

        <tr *ngIf="isEmpty">
          <td colspan="4" class="rm-brd">
            <span class="text-info text-small">No Standard Routes found.</span>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>
